import { Component, OnInit } from '@angular/core';
import { EventsService } from '../events.service';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddFirmComponent } from './add-firm/add-firm.component';
import { Constant } from '../../common/constants';
import { NotificationsService } from '../../common/notifications.service';
import { DialogService } from '../../common/dialog.service';

@Component({
  selector: 'app-event-firms',
  templateUrl: './event-firms.component.html',
  styleUrls: ['./event-firms.component.less']
})
export class EventFirmsComponent implements OnInit {
  firms: any[] = [];
  eventid: number;

  constructor(
    private service: EventsService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dialogService: DialogService,
    private notificationService: NotificationsService) { }

  ngOnInit() {
    this.load();
  }

  load() {
    this.route.paramMap.subscribe(paramMap => {
      this.eventid = Number(paramMap.get('id'));
      if (!this.eventid) {
        return;
      }
      this.service.getEventFirms(this.eventid)
        .subscribe(methods => {
          this.firms = methods as any[];
        });
    });
  }

  openModal() {
    const modalRef = this.modalService.open(AddFirmComponent, { size: 'lg' });
    modalRef.componentInstance.eventid = this.eventid;
    modalRef.result.then(result => {
      if (!!result) {
        this.load();
        this.notificationService.notify.emit(Constant.TICKETS_GENERATED_NOTIFICATION);
      }
    });
  }

  openDeleteModal(id) {
    this.dialogService.confirmDialog('Are you sure you want to delete this company?')
      .then(result => {
        if (!!result) {
          this.service.deleteFirmForEvent(id)
            .subscribe(methods => {
              this.load();
              this.notificationService.notify.emit(Constant.TICKETS_GENERATED_NOTIFICATION);
            });
        }
      }, () => { });
  }
}
